import React, { Component } from 'react';
import { soundManager } from 'soundmanager2';
const stream = 'http://stream.customchannels.net/sotherly_florida_96.mp3';

class PlayPause extends Component {
  constructor(props) {
    super(props);
    this.state = {
        playing: false,
        volume: 80
    };

    this.playPause = this.playPause.bind(this);
  }

  componentWillMount(){
    var self = this;
    soundManager.setup({
      debugMode: false,
      onready: function(){
        self.stream = soundManager.createSound({
          autoLoad: true,
          volume: self.state.volume,
          stream: true,
          id: 'stream',
          url: stream
        });
      }
    });
  }

  playPause(){
      if(!this.state.playing){
          this.stream.play();
          this.setState({ playing: true });
      }else{
          this.stream.stop();
          this.setState({ playing: false });
      }
  }

  render() {
    return (
      <div className="Control">
          <a onClick={ this.playPause } id="play-pause"><i className={ !this.state.playing ? "fa fa-play-circle-o fa-4x" : "fa fa-pause-circle-o fa-4x" }></i></a>
      </div>
    );
  }
}

export default PlayPause;



// WEBPACK FOOTER //
// ./src/PlayPause.js